export const news = [
  {
    id: "1",
    title: "《危险关系》口碑登顶，法式情感片为何再度风靡",
    category: "影片推荐",
    date: "2025-09-28",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20an%20elegant%20dimly%20lit%20parisian%20ballroom%20with%20deep%20navy%20and%20warm%20amber%20lighting%2C%20refined%20artistic%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-01&orientation=landscape",
    summary: "上映首月便登顶多国口碑榜，《危险关系》让法式情感电影重新回到大众视野。",
    paragraphs: [
      "由克莱尔·杜邦执导的《危险关系》自在多个影展首映以来便收获高度评价。影片以现代视角重新解构经典的情感博弈题材，凭借锋利的台词与出色的表演张力，在上映首月便登顶多国口碑榜单。",
      "影评人普遍认为，影片的成功在于它没有沉溺于怀旧，而是将当代人面对亲密关系时的犹豫与自尊融入叙事，让观众在其中看到自己的影子。",
      "从美术到配乐，《危险关系》都保持着极高的完成度。业内人士指出，这类兼具艺术质感与观赏性的作品，正在重新点燃观众对欧陆情感电影的兴趣。",
      "目前该片已在多个地区进入年度佳片候选名单，后续表现值得持续关注。",
    ],
    tags: ["年度佳片", "法国电影", "口碑"],
  },
  {
    id: "2",
    title: "欧洲艺术电影新浪潮：年轻导演正在讲述什么",
    category: "深度专题",
    date: "2025-09-15",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20a%20young%20film%20crew%20with%20a%20camera%20on%20a%20european%20street%20at%20golden%20hour%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20documentary%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-02&orientation=landscape",
    summary: "一批年轻创作者正在用更私人的视角，重新定义欧陆文艺电影的表达方式。",
    paragraphs: [
      "近年来，欧洲影坛涌现出大量由年轻导演执导的作品。与前辈相比，他们更愿意将镜头对准日常生活的细节，用私人化的视角讲述普遍的情感。",
      "这些影片往往预算有限，却在叙事结构与影像风格上大胆实验。从长镜头的运用，到对自然光与真实场景的偏爱，都体现出一种回归质朴的倾向。",
      "有评论指出，这股浪潮的意义不仅在于作品本身，更在于它为观众提供了一种更贴近真实的观看体验。",
      "随着流媒体平台加大对作者电影的投入，这些年轻创作者的作品正获得更广泛的传播渠道。",
    ],
    tags: ["新浪潮", "导演", "行业观察"],
  },
  {
    id: "3",
    title: "2025 年值得关注的十部欧美剧情片前瞻",
    category: "影片推荐",
    date: "2025-09-02",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20collage%20of%20film%20reels%20and%20a%20projector%20beam%20in%20a%20dark%20theater%20with%20warm%20amber%20and%20deep%20navy%20tones%2C%20artistic%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-03&orientation=landscape",
    summary: "从作者电影到类型佳作，今年下半年有哪些剧情片值得我们走进影院？",
    paragraphs: [
      "随着下半年的到来，多部备受期待的欧美剧情片陆续公布档期。这些作品题材各异，既有聚焦家庭关系的细腻之作，也有探讨社会议题的严肃表达。",
      "其中不乏来自知名导演的新作，也有初出茅庐的创作者带来的惊喜。共同点是它们都在尝试用影像回答同一个问题：我们如何与彼此相处。",
      "本文将按上映时间梳理十部值得关注的影片，并简要介绍其看点与制作背景，供影迷提前规划观影清单。",
      "需要提醒的是，具体上映信息可能随发行安排调整，请以官方公布为准。",
    ],
    tags: ["观影清单", "前瞻", "剧情片"],
  },
  {
    id: "4",
    title: "影展观察：小成本作品如何撬动大关注",
    category: "影展资讯",
    date: "2025-08-20",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20a%20film%20festival%20red%20carpet%20at%20dusk%20with%20warm%20amber%20lights%20and%20deep%20blue%20sky%2C%20elegant%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-04&orientation=landscape",
    summary: "在今年的各大影展上，一批低预算作品出人意料地成为媒体与观众讨论的焦点。",
    paragraphs: [
      "影展历来是发现新锐创作者的重要舞台。今年，多部制作成本并不高的作品凭借扎实的剧本与独特的视角，在展映后迅速引发讨论。",
      "有制片人表示，观众对\"真诚\"的敏感度正在提高。相比华丽的场面，一个讲得好的故事往往更能打动人心。",
      "这些作品的成功也为更多独立创作者提供了信心：资源有限并不意味着表达受限，关键在于找到属于自己的语言。",
      "影展结束后，其中数部作品已确定获得更广泛的发行机会，值得后续留意。",
    ],
    tags: ["影展", "独立电影", "观察"],
  },
  {
    id: "5",
    title: "流媒体时代，文艺电影找到了新的观众",
    category: "行业动态",
    date: "2025-08-05",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20a%20cozy%20living%20room%20at%20night%20watching%20a%20film%20on%20screen%20with%20warm%20amber%20glow%20and%20deep%20navy%20shadows%2C%20modern%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-05&orientation=landscape",
    summary: "流媒体平台的兴起，正在改变文艺电影的传播路径与观众构成。",
    paragraphs: [
      "过去，文艺电影常常受限于院线排片，难以触达更广泛的观众。流媒体的普及在很大程度上改变了这一局面。",
      "平台通过算法推荐与专题策划，让小众作品获得了被发现的机会。数据显示，越来越多的观众开始主动搜索并观看非主流院线影片。",
      "不过，业内也提醒，平台的分发逻辑与院线仍有差异，如何平衡艺术表达与观众触达，仍是创作者需要面对的课题。",
      "总体而言，新的传播渠道为文艺电影打开了更广阔的空间。",
    ],
    tags: ["流媒体", "行业", "发行"],
  },
  {
    id: "6",
    title: "经典重映：那些值得再看一遍的欧陆爱情片",
    category: "深度专题",
    date: "2025-07-18",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20an%20old%20film%20projector%20and%20reels%20in%20a%20vintage%20cinema%20with%20warm%20amber%20tones%20and%20deep%20blue%20shadows%2C%20nostalgic%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-06&orientation=landscape",
    summary: "一批经典欧陆爱情片陆续以修复版重返大银幕，重温银幕上的浪漫时刻。",
    paragraphs: [
      "随着修复技术的成熟，越来越多的经典影片得以重新与观众见面。近期，多部欧陆爱情片的重映计划引发影迷关注。",
      "这些作品虽然拍摄年代久远，但其中关于爱情与成长的讨论，依然能引起当代观众的共鸣。",
      "重映不仅是一次怀旧，也为年轻观众提供了在大银幕上接触经典的机会。有影院表示，重映场的观众构成出乎意料地年轻。",
      "如果你也喜欢在日常中发现浪漫，不妨留意身边影院的重映排期。",
    ],
    tags: ["经典", "重映", "爱情片"],
  },
  {
    id: "7",
    title: "幕后揭秘：一部独立剧情片是怎样诞生的",
    category: "深度专题",
    date: "2025-06-30",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20behind%20the%20scenes%20scene%20of%20a%20film%20set%20with%20lights%20and%20camera%20equipment%20at%20night%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20documentary%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-07&orientation=landscape",
    summary: "从剧本到剪辑，一部独立剧情片的诞生背后，是无数细节的打磨与坚持。",
    paragraphs: [
      "一部电影的诞生远比观众想象的复杂。对于独立创作者而言，每一个环节都需要在有限资源下做出取舍。",
      "从前期筹备的剧本打磨，到拍摄现场的时间管理，再到后期的剪辑与调色，团队往往身兼数职。",
      "本文采访了几位参与独立剧情片制作的幕后工作者，还原了那些不为人知的日常，也呈现了他们对电影的热爱。",
      "正是这些幕后坚持，让一部部作品得以最终呈现在观众面前。",
    ],
    tags: ["幕后", "独立制作", "专题"],
  },
  {
    id: "8",
    title: "从剧本到银幕：情感片叙事结构的三次进化",
    category: "行业动态",
    date: "2025-06-12",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20a%20screenwriter%20desk%20with%20notes%20and%20warm%20lamp%20light%20against%20deep%20navy%20shadows%2C%20literary%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-08&orientation=landscape",
    summary: "情感片的叙事方式在过去数十年里经历了三次重要演变，每一次都重塑了观众的观看习惯。",
    paragraphs: [
      "情感题材之所以经久不衰，在于它始终与人的真实处境紧密相连。而叙事结构的变化，往往折射出社会观念的变迁。",
      "从早期的线性因果叙事，到后来的多线并进，再到如今更强调留白与余韵的表达，观众对情感的理解也在不断丰富。",
      "创作者们越来越意识到，比起给出答案，提出一个好问题同样重要。",
      "理解这些结构上的演化，有助于我们更深入地欣赏一部作品。",
    ],
    tags: ["叙事", "编剧", "行业"],
  },
];